import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CalculatorService {

  saveAndPayEvent: Subject<void> = new Subject<void>();

  constructor() {
  }
}
